<template>
  <div
    :class="{'active': collapsed}"
    class="expandable"
  >
    <button
      :id="id"
      :class="{'is-active': collapsed, 'expandable__button--move': (offset < 0)}"
      class="expandable__button button-clean tab-nav__label text-light"
      @click.prevent="onToggle()"
    >
      <div class="tab-nav__label-text">
        <slot name="buttonLabel" />
      </div>
      <icon
        name="plus-circle"
        size="lg"
      />
    </button>
    <expand-transition
      :duration="animationDuration"
      :margin-top="offset"
    >
      <div
        v-show="collapsed"
        :aria-hidden="(!collapsed).toString()"
      >
        <slot name="content" />
      </div>
    </expand-transition>
  </div>
</template>

<script>
import { Icon } from 'zv-components'
import ExpandTransition from './ExpandTransition'

export default {
  name: 'ZvExpandable',
  components: { Icon, ExpandTransition },

  props: {
    offset: {
      type: Number,
      default: 0,
    },
    animationDuration: {
      type: Number,
      default: 500,
    },
  },

  data () {
    return {
      collapsed: false,
      id: Math.random().toString(36).substr(2, 10),
    }
  },

  methods: {
    onToggle () {
      this.collapsed = !this.collapsed
    },
  },
}
</script>
